<template>
    <v-card elevation="5" outlined shaped>
        <v-dialog v-model="elModal" max-width="1200" class="text-cenet">
            <v-card elevation="5" outlined shaped>
              <v-card-title>
                <span>
                  <h5>ESTUDIANTE</h5>
                </span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" md="2">
                      <v-text-field type="" v-model="uniest" label="UNICODIGO" @keyup.enter="buscarEstudiante()">
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-text-field type="text" v-model="pat" label="PATERNO" @input="pat = pat.toUpperCase()"
                        @keyup.enter="buscarEstudiante()">
                      </v-text-field>
                    </v-col>
      
                    <v-col cols="12" md="2">
                      <v-text-field type="text" v-model="mat" label="MATERNO" @input="mat = mat.toUpperCase()"
                        @keyup.enter="buscarEstudiante()">
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-text-field type="text" v-model="nomest" label="NOMBRES" @input="nomest = nomest.toUpperCase()"
                        @keyup.enter="buscarEstudiante()">
                      </v-text-field>
                    </v-col >
                    <v-col cols="1"></v-col>
                    <v-col cols="1">
                      <!--v-btn class="mx-2" fab dark small color="#002245" @click="buscarEstudiante()" style="float: right"
                        title="BUSCAR ESTUDIANTE">
                        <v-icon dark> mdi-account-search </v-icon>
                      </v-btn-->
                      <v-btn 
                        rounded
                        color="#002245"
                        class="ma-2 white--text"
                        @click="buscarEstudiante()"
                         style="float: right"
                        
                      >
                      BUSCAR 
                        <v-icon
                          right
                          dark
                        >
                        mdi-account-search
                        </v-icon>
                      </v-btn>
                      </v-col>
                      <v-col cols="1"></v-col>
                      <v-col cols="1">
                      <v-btn 
                        rounded
                        color="#EE680B"
                        class="ma-2 white--text"
                        @click="close"
                        style="float: right"
                      >
                      CANCELAR
                        <v-icon
                          right
                          dark
                        >
                        mdi-close-circle-outline
                        </v-icon>
                      </v-btn>
                    </v-col>
      
                    <v-col cols="12">
                      <v-data-table :headers="headersEstudiante" 
                           :items="datosEstudiante" 
                           @click:row="($event, {item})=>seleccionarEstudiante(item)"
                           :search="pat" 
                           :items-per-page="5"
                        class="elevation-1" id="tableId">
                        <template #[`item.actions`]="{ item }">
      
                          <v-icon color="#0091EA" medium class="mr-2" @click="seleccionarEstudiante(item)"
                            title="SELECCIONAR ESTUDIANTE">
                            mdi-check-circle
                          </v-icon>
                        </template>
                      </v-data-table>
      
      
                    </v-col>
                    <!--v-col cols="10"> </v-col>
                    <v-col cols="2">
                      <v-btn class="mx-2" fab dark small color="#EE680B" @click="close" style="float: right" title="SALIR">
                        <v-icon dark> mdi-close-circle-outline </v-icon>
                      </v-btn>
                    </v-col-->
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
  
  
      <v-dialog v-model="tarjetaModal" max-width="500" class="text-cenet">
        <v-card elevation="5" outlined shaped>
          <v-card-title>
            <span>
              <h5>AÑADIR NUEVA TARJETA</h5>
            </span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
         <v-col cols="12" md="2"> </v-col>
              <!--centreadores-->
              <v-col cols="12" md="8">
                <v-text-field v-model="numeroTarjeta" hint="UTILICE EL LECTOR RFID" :rules="tarjetaRules"
                  @input="numeroTarjeta = numeroTarjeta.toUpperCase()" label="NÚMERO DE TARJETA"  persistent-hint required>
                </v-text-field>
              </v-col>
  
              <v-col cols="12" md="2"> </v-col>
                <v-col cols="12" md="2"> </v-col>
           
                <!--centreadores-->
                <v-col cols="12" md="8">
                  <v-menu
                    v-model="menuFechaVencimiento1"
                    
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="nuevaFechaVencimiento1"
                        label="FECHA DE VENCIMIENTO"
                        color="blue"
                        prepend-icon="mdi-calendar"
                        readonly
                         :rules="fechaVencimientoRules"
                
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      :first-day-of-week="1"
                      locale="es-AR"
                      color="blue"
                      v-model="nuevaFechaVencimiento1"
                      @input="menuFechaVencimiento1 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
  
  
              <v-col cols="12" md="2"> </v-col>
              <v-col cols="12" md="2"> </v-col>
             
              <v-col cols="12" md="8">
                <v-text-field v-model="observaciones"  
                  @input="observaciones = observaciones.toUpperCase()" label="OBSERVACIONES" ></v-text-field>
              </v-col>
              
          
                <v-col cols="12" md="6"> </v-col>
              <v-col cols="12" md="6">
                <v-toolbar dense shaped color="#002245">
                  <v-toolbar-title style="color:#ffffff">
                    <h6>OPCIONES</h6>
                  </v-toolbar-title>
  
                  
                  <v-btn  class="mx-2" fab dark x-small color="#EE680B" @click="registrarTarjeta()"
                    style="float: left" title="REGISTRAR TARJETA">
                    <v-icon dark> mdi-content-save-plus-outline </v-icon>
                  </v-btn>
                  <v-btn class="mx-2" fab dark x-small color="#EE680B" @click="closeTarjeta()" style="float: left"
                    title="CERRAR">
                    <v-icon dark> mdi-close </v-icon>
                  </v-btn>
               
  
                </v-toolbar>
              </v-col>
  
          
  
               
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
  
  
  
      <v-dialog v-model="modificarTarjetaModal" max-width="500" class="text-cenet">
        <v-card elevation="5" outlined shaped>
          <v-card-title>
            <span>
              <h5>MODIFICAR FECHA DE VENCIMIENTO DE LA  TARJETA</h5>
            </span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
         <v-col cols="12" md="2"> </v-col>
              <!--centreadores-->
              <v-col cols="12" md="8">
                <v-text-field v-model="fechaVencimientoActual"  :rules="tarjetaRules"
                  @input="fechaVencimientoActual = fechaVencimientoActual.toUpperCase()" label="FECHA DE VENCIMIENTO ACTUAL"   required>
                </v-text-field>
              </v-col>
              <v-col cols="12" md="2"> </v-col>
             
  
  
                 <v-col cols="12" md="2"> </v-col>
              <!--centreadores-->
              <v-col cols="12" md="8">
              <v-menu v-model="menuFechaVencimiento" :close-on-content-click="false" :nudge-right="40"
                                  transition="scale-transition" offset-y min-width="auto">
                                  <template v-slot:activator="{ on, attrs }">
                                      <v-text-field  v-model="nuevaFechaVencimiento" label="NUEVA FECHA DE VENCIMIENTO" color="blue" prepend-icon="mdi-calendar" readonly
                                          v-bind="attrs" v-on="on"></v-text-field>
                                  </template>
                                  <v-date-picker  :first-day-of-week="1"
                     locale="es-AR" color="blue" v-model="nuevaFechaVencimiento" @input="menuFechaVencimiento = false"></v-date-picker>
                              </v-menu>
              </v-col>
              <v-col cols="12" md="2"> </v-col>
              <v-col cols="12" md="2"> </v-col>
             
              <v-col cols="12" md="8">
                <v-text-field v-model="observaciones"  
                  @input="observaciones = observaciones.toUpperCase()" label="OBSERVACIONES" ></v-text-field>
              </v-col>
              
          
                <v-col cols="12" md="6"> </v-col>
              <v-col cols="12" md="6">
                <v-toolbar dense shaped color="#002245">
                  <v-toolbar-title style="color:#ffffff">
                    <h6>OPCIONES</h6>
                  </v-toolbar-title>
  
                  
                  <v-btn  class="mx-2" fab dark x-small color="#EE680B" @click="actualizarTarjetaEstudiante()"
                    style="float: left" title="ACTUALIZAR TARJETA">
                    <v-icon dark> mdi-content-save-plus-outline </v-icon>
                  </v-btn>
                  <v-btn class="mx-2" fab dark x-small color="#EE680B" @click="closeModificarTarjeta()" style="float: left"
                    title="CERRAR">
                    <v-icon dark> mdi-close </v-icon>
                  </v-btn>
               
  
                </v-toolbar>
              </v-col>
  
          
  
               
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
  
      <v-dialog v-model="gestionModal" max-width="400" class="text-cenet">
        <v-card elevation="5" outlined shaped>
          <v-card-title>
            <span>
              <h5>GESTION</h5>
            </span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-data-table
                    :headers="headersGestion"
                    :items="datosGestion"
                    :items-per-page="5"
                    @click:row="($event, {item})=>seleccionarGestion(item)"
                    class="elevation-1"
                    id="tableId"
                    hide-default-footer
                    disable-pagination
                  >
                    <!--template #[`item.actions`]="{ item }">
                      <v-icon
                        color="#0091EA"
                        small
                        class="mr-2"
                        @click="seleccionarGestion(item)"
                        title="SELECCIONAR GESTION"
                      >
                        mdi-check-circle
                      </v-icon>
                    </template-->
                  </v-data-table>
                </v-col>
                <v-col cols="10"> </v-col>
                <v-col cols="2">
                  <v-btn
                    class="mx-2"
                    fab
                    dark
                    x-small
                    color="#EE680B"
                    @click="closeGestion"
                    style="float: right"
                    title="SALIR"
                  >
                    <v-icon dark> mdi-close-circle-outline </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
   
  
  
  
          <div>
              <v-alert dense color="#EE680B" style="color: #ffffff">
                  <h5>ESTADO ACTUAL DEL ESTUDIANTE</h5>
              </v-alert>
          </div>
          <v-row >
            <v-col  cols="12" md="2" xs="1">
                <v-list-item>
                  <v-list-item-title>
                    <h5>UNICODIGO:</h5>
                  </v-list-item-title>
                </v-list-item>
              </v-col>
              <v-col   cols="12" md="2" xs="1">
                <v-list-item>
                  <v-list-item-title>
                    <h3 style="text-align: center; background: #FFE082;">{{unicodigo}}</h3>
                  </v-list-item-title>
                </v-list-item>
              </v-col>
              <v-col  cols="12" md="2" xs="1">
                <v-list-item>
                  <v-list-item-title>
                    <h5>GESTION ACTUAL DEL ESTUDIANTE:</h5>
                  </v-list-item-title>
                </v-list-item>
              </v-col>
              <v-col   cols="12" md="2" xs="1">
                <v-list-item>
                  <v-list-item-title>
                    <h3 style="text-align: center; background:#B3E5FC;">{{gestion}}</h3>
                  </v-list-item-title>
                </v-list-item>
              </v-col>
              <v-col   cols="12" md="4" xs="1"></v-col>
              <v-col   cols="12" md="2" xs="1">
                <v-list-item>
                  <v-list-item-title>
                    <h5>POSTERGACION VIGENTE:</h5>
                  </v-list-item-title>
                </v-list-item>
              </v-col>
              <v-col   cols="12" md="2" xs="1">
                <v-list-item>
                  <v-list-item-title>
                    <h3 style="text-align: center; background: #9CCC65;">{{fechavigente}}</h3>
                  </v-list-item-title>
                </v-list-item>
              </v-col>
              <v-col   cols="12" md="8" xs="8"></v-col>
          
          <v-col   cols="12" md="1" xs="1">
            <v-btn class="mx-2" fab dark x-small color="#EE680B" @click="showBuscarEstudiante()" style="float: right"
              title="BUSCAR ESTUDIANTE">
              <v-icon dark> mdi-gesture-double-tap </v-icon>
            </v-btn>
          </v-col>
          <v-col  cols="12" md="5">
            <v-text-field 
            v-model="nombreCompleto" label="ESTUDIANTE" disabled required>
          </v-text-field>
          <br>
              <v-text-field v-model="carrera" label="CARRERA" disabled required></v-text-field>
          </v-col>

          
          <v-col cols="12" md="2" >
           
           
                <v-card
                class="mx-auto"
                color="#EEEEEE"
                dark
                max-width="183"
                elevation="5" outlined shaped
                
              >
              
            
            
            
              
                  <v-list-item class="grow" style="float: center">
                    <v-list-item-avatar color="#FFFFFF" size="150
                                                                    ">
                      <v-img
                        class="elevation-6"
                        alt=""
                        :src="urlFoto"
                      ></v-img>
                    </v-list-item-avatar>
            
            
                  
                  </v-list-item>
                
              </v-card>
          </v-col>
          <v-col cols="12" md="1"></v-col>

          <v-col cols="12" md="2"></v-col>
          <!--v-col cols="12" md="1">
            <v-btn class="mx-2" fab dark x-small color="#EE680B" @click="showGestion()" style="float: right"
              title="BUSCAR GESTION">
              <v-icon dark> mdi-gesture-double-tap </v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field v-model="gestion" label="GESTION" disabled required></v-text-field>
          </v-col-->
        
       </v-row>
    
  
       <v-col cols="12" md="12"></v-col>
  
  
     
       
          <v-card elevation="5" outlined shaped>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                   <v-list-item>
                <v-list-item-title class="text-left">
                  <h5>TARJETA REGISTRADA</h5>
                </v-list-item-title>
              </v-list-item>
  
                  <v-data-table :headers="headersTarjetas" 
                  :items="datosTarjetasEstudiante" 
                  hide-default-footer
                  disable-pagination
                  class="elevation-1"

                    id="tableId">
                    <template #[`item.est`]="{ item }">
                      <v-chip :color="getColorActivo(item.est)" dark center-active>
                        {{ item.est }}
                      </v-chip>
                    </template>
  
                     <template #[`item.numtarjeta`]="{ item }">
                              <v-chip   class="ma-2"  color="#3191aa" label dark>
                                 {{ item.numtarjeta }}
                                </v-chip>
                              </template>                          
                             
                             
  
  
                    <template #[`item.actions`]="{ item }" >
                      <!-- <v-icon v-if="item.est == 'INACTIVO'" small class="mr-2" @click="activarTarjeta(item)"
                        title="ACTIVAR TARJETA" color ="blue">
                        mdi-check-circle-outline
                      </v-icon>
                      <v-icon v-if="item.est == 'ACTIVO'" small class="mr-2" @click="desactivarTarjeta(item)"
                        title="DESACTIVAR TARJETA" color ="red"> 
                        mdi-cancel
                      </v-icon> -->
                      <v-icon v-if="item.est == 'ACTIVO' &&  banderafechavigente==0 " 
                                color ="#244a97" large class="mr-2" @click="seleccionarTarjetaEstudiante(item)" title="ACTUALIZAR CARNET">
                        mdi-update
                      </v-icon>
  
                      <!--v-icon small class="mr-2" @click="seleccionarDelFormAcad(item)" title="ELIMINAR INFORMACION">
                            mdi-delete
                          </v-icon-->
                    </template>
                  </v-data-table>
  
                </v-col>
                <v-col cols="12" md="12" v-if="bandbeca == 'TIENEBECA'">
                    <v-alert color="#9CCC65" dark dense icon="mdi-information-slab-circle-outline" style="color: black" prominent>
                     <h3> {{beca}}</h3> 
                    </v-alert>
                  </v-col>
                  <v-col cols="12">
                    <v-list-item>
                 <v-list-item-title class="text-left">
                   <h5>INFORMACION DE DEUDAS Y PAGOS</h5>
                 </v-list-item-title>
               </v-list-item>
   
                   <v-data-table :headers="headersPagosgestion" 
                   :items="datosDeudaxgesestudiante" 
                   hide-default-footer
                   disable-pagination
                   class="elevation-1"
 
                     id="tableId">
                     <template #[`item.deud`]="{ item }">
                       <v-chip :color="getColorDeuda(item.deud)" dark center-active>
                         {{ item.deud }}
                       </v-chip>
                     </template>
   
                     
                   </v-data-table>
   
                 </v-col>
                 <v-col cols="12">
                    <v-list-item>
                        <v-list-item-title class="text-left">
                          <h5>OBSERVACIONES</h5>
                        </v-list-item-title>
                      </v-list-item>
                    <v-data-table :headers="headersObservacion1" :items="datosDeudaObservacion" hide-default-footer
                      disable-pagination class="elevation-1" id="tableId">
                      
                    </v-data-table>
    
    
                  </v-col>
  
              <!---->
  
  
              </v-row>
  
  
            </v-card-text>
          </v-card>
  
        
      
  
     
  
  
  
      <div class="text-center">
        <v-snackbar v-model="snackbarOK" :timeout="timeout" top right shaped dense color="#EE680B" outlined>
          <strong>{{ mensajeSnackbar }}</strong>
  
  
          <template v-slot:action="{ attrs }">
            <v-icon right v-bind="attrs" @click="snackbarOK = false">
              mdi-close
            </v-icon>
          </template>
        </v-snackbar>
      </div>
      <div class="text-center">
  
        <v-snackbar v-model="snackbarError" :timeout="timeout" top right shaped dense color="#EE680B" outlined>
          <strong>{{ mensajeSnackbar }}</strong>
  
          <template v-slot:action="{ attrs }">
            <v-icon right v-bind="attrs" @click="snackbarError = false">
              mdi-close
            </v-icon>
          </template>
        </v-snackbar>
      </div>
  
      <div class="text-center">
  
        <v-snackbar v-model="snackbarError1" :timeout="timeout" top right shaped dense color="#EE680B" outlined>
          <strong>{{ mensajeSnackbarHorario }}</strong>
  
          <template v-slot:action="{ attrs }">
            <v-icon right v-bind="attrs" @click="snackbarError1 = false">
              mdi-close
            </v-icon>
          </template>
        </v-snackbar>
      </div>
      <div class="text-center">
  
        <v-snackbar v-model="snackbarError2" :timeout="timeout" top right shaped dense color="#EE680B" outlined>
          <strong>{{ mensajeSnackbarGrupoLleno }}</strong>
  
          <template v-slot:action="{ attrs }">
            <v-icon right v-bind="attrs" @click="snackbarError2 = false">
              mdi-close
            </v-icon>
          </template>
        </v-snackbar>
  
        <v-snackbar v-model="snackbarError3" :timeout="timeout" top right shaped dense color="#EE680B" outlined>
          <strong>{{ mensajeSnackbarNivel }}</strong>
  
          <template v-slot:action="{ attrs }">
            <v-icon right v-bind="attrs" @click="snackbarError3 = false">
              mdi-close
            </v-icon>
          </template>
        </v-snackbar>
        <v-snackbar v-model="snackbarError4" :timeout="timeout" top right shaped dense color="#EE680B" outlined>
          <strong>{{ mensajeSnackbarQuitarMateriaNivel }}</strong>
  
          <template v-slot:action="{ attrs }">
            <v-icon right v-bind="attrs" @click="snackbarError4 = false">
              mdi-close
            </v-icon>
          </template>
        </v-snackbar>
        <v-snackbar v-model="snackbarError5" :timeout="timeout" top right shaped dense color="#EE680B" outlined>
          <strong>{{ mensajeSnackbarDocumentos }}</strong>
  
          <template v-slot:action="{ attrs }">
            <v-icon right v-bind="attrs" @click="snackbarError5 = false">
              mdi-close
            </v-icon>
          </template>
        </v-snackbar>
        <v-snackbar v-model="snackbarError6" :timeout="timeout" top right shaped dense color="#EE680B" outlined>
          <strong>{{ mensajeSnackbarFechaInscripcion }}</strong>
  
          <template v-slot:action="{ attrs }">
            <v-icon right v-bind="attrs" @click="snackbarError6 = false">
              mdi-close
            </v-icon>
          </template>
        </v-snackbar>
      </div>
  
    </v-card>
  </template>
  <script>
  import axios from "axios"
  import VueHtml2pdf from 'vue-html2pdf'
  export default {
    data() {
      return {
        
        posts:[], 
  
        fechaVencimientoActual1:"",
        menuFechaVencimiento1: "",
        aux: [],
        cadena: "",
        accLevelIds: 1,
  
        datosmolinetes: [],
        deptCode: 1,
        bandbeca:"",
        datosBeca:[],
        beca:"",
        tarjetaModal: 0,
        modificarTarjetaModal: 0,
        fechaVencimientoActual:"",
        nuevaFechaVencimiento: "",
        menuFechaVencimiento: "",
        modificarTarjetaModal:0,
        idTarjeta:"",
        observaciones:"NINGUNA",
        numeroTarjeta:"",
        gradoAcademico: "",
        datosPromedioGestiones: [],
        matricula: "",
        nuevaFechaVencimiento1:"",
        datosDocumentosPendientes: [],
        contadorGestiones: 0,
        datosKardexGestion: [],
        imprimirPaginacion: 0,
        materiasReprobadas: 0,
        sumatoriaNotasFinales: 0,
        promedioMateriasAprobadas: 0,
        materiasAprobadas: 0,
        materiasTomadas: 0,
        totalHorasAcademicasVencidas: 0,
  
        segundos: "",
        minutos: "",
        hora: "",
        imprimirHora: "",
        today: "",
        imprimirFecha: "",
        dia: "",
        mes: "",
        año: "",
        fechaInscripcionIni: "",
        fechaInscripcionFin: "",
        datosFechaInscripcion: [],
        datosDeudaxgesestudiante:[],
        datosRecursado: '',
        recursada: 'N',
        hoy: "",
        hoy1: "",
        banderafechavigente:0,
        fechaEntrega: "",
        tipoInscripcion: "WEBADM",
        mat: "",
        pat: "",
        id_estudiante: "",
        unicodigo: "",
        num_documento: "",
        paterno: "",
        materno: "",
        nombres: "",
        nombreCompleto: "",
        datosCarrera: [],
        idPlanestudio: "",
        idCarrera: "",
        carrera: "",
        gestion: "",
        idGestion: "",
        datosOfertaMaterias: [],
        idMateria: "",
        detalleModal: 0,
        datosCantidadEstGrupo: [],
        datosGruposInscripcion: [],
        idTurno: "",
        datosTurno: [],
        turno: "",
        idGrupoDocente: "",
        idTipoModalidad: 1,
        modalidad: "",
        paralelo: "",
        capacidad: "",
        tipoGrupo: "",
        idNivel: "",
        idUsuario: 6,
        idPlanEconomico: 115,
        yaInscrito: false,
        cantidadMaximaMaterias: 7,
        //maxMateriasPreinscritas: 0,
        cantidadActualMaterias: "",
        datosGruposPreInscripcion: [],
        idNota: "",
        minimoNivel: "",
        datosOfertaMateriasNivel: [],
        idGrupoAux: "",
  
  
        //tipo: "PRACTICO",
        gruposPracticosModal: 0,
        gestionModal:0,
        horarioModal: 0,
        datosHorario: [],
        idFranjaHoraria: "",
        idDia: "",
        cantAct: "",
        datosCantidadEspacio: [],
        datosHorariosGrupo: [],
        datosFranjaHoraria: [],
        //datosHorarioConvertido: [LUNES, MARTES, MIERCOLES, JUEVES, VIERNES, SABADO, DOMINGO],
        tienePractico: "FALSE",
        choqueHorario: 0,
        idGrupoPadre: "",
        esCompartido: "",
        kardexModal: 0,
        datosDocumentos: [],
        choquecant: 0,
        search: "",
        inpNum: "",
        id_docente: "",
        tipodocente: "",
        searchDocente: "",
        selectGenero: "",
        datosGenero: ["FEMENINO", "MASCULINO"],
        auxmat: "",
        auxpat: "",
        auxnomest:"",
        nomest:"",
        uniest: "",
        datosOfertaCorregido: [],
        datosCantMateriasEst: [],
        datosEstudiante: [],
        datosGestion: [],
        datosTarjetasEstudiante: [],
        datosGruposInscripcionPracticos: [],
        est: "",
        elModal: 0,
        tarjetaModal: 0,
        gestionModal: 0,
        turnoModal: 0,
        horarioModal1: 0,
        documentosModal: 0,
        datosNivelesPreinscritos: [],
        nivelMaximoPreInscrito: "",
        itencant: 0,
        doble: 0,
        itemcantidadModal: 0,
        deleteDialog: 0,
        oldNum: "",
        iditemdet: "",
        iditemdet1: "",
        totaldet: "",
        idtrans: "",
        busest: "",
        idcategoriaest: "",
        categoriaest: "",
        tiponacional: "",
        paisest: "",
        snackbarOK: false,
        mensajeSnackbar: "",
        mensajeSnackbarGrupoLleno: "GRUPO LLENO",
        mensajeSnackbarNivel: "AÚN TIENE MATERIAS DE NIVEL INFERIOR",
        mensajeSnackbarHorario: 'CHOQUE DE HORARIO',
        mensajeSnackbarCantidadMaximaMaterias: 'CANTIDAD MAXIMA DE MATERIAS TOMADAS',
        mensajeSnackbarQuitarMateriaNivel: "PRIMERO QUITE MATERIAS DE NIVEL SUPERIOR",
        mensajeSnackbarDocumentos: "REGULARICE SU DOCUMENTACIÓN",
        mensajeSnackbarFechaInscripcion: "FUERA DE FECHA DE INSCRIPCIONES",
        snackbarError: false,
        snackbarError1: false,
        snackbarError2: false,
        snackbarError3: false,
        snackbarError4: false,
        snackbarError5: false,
        snackbarError6: false,
        mensajeError: "",
        fechavigente:"",
        timeout: 2000,
  
        alert: { show: false, message: "" },
        alertdocumento: { show: false, message: "" },
        headersGestion: [
          { text: "GESTION", value: "nom", sortable: false , class: 'my-header-style'},
         // { text: "OPCIONES", value: "actions", sortable: false },
        ],
  
        headersTurno: [
  
          { text: "TURNO", value: "turno", sortable: true , class: 'my-header-style'},
          { text: "OPCIONES", value: "actions", sortable: false },
        ],
       
       
      
       
       
        tarjetaRules: [
        (v) => !!v || "UTILICE EL LECTOR RFID",
        (v) =>
          (v && v.length <= 100) ||
          "",
      ],
      
      headersEstudiante: [
            { text: "UNICODIGO", value: "unicod", sortable: true, class: 'my-header-style' },
            { text: "MATRICULA", value: "matr", sortable: true, class: 'my-header-style' },
            { text: "PATERNO", value: "pat", sortable: false, class: 'my-header-style' },
            { text: "MATERNO", value: "mat", sortable: false, class: 'my-header-style' },
            { text: "NOMBRES", value: "nom", sortable: false, class: 'my-header-style' },
            { text: "CARRERA", value: "carre", sortable: false, class: 'my-header-style' }
           // { text: "OPCIONES", value: "actions", sortable: false },
          ],
        headersTarjetas: [
  
          { text: "N°", value: "col", sortable: false , class: 'my-header-style'},
          { text: "TARJETA RFID", value: "numtarjeta", sortable: false , class: 'my-header-style'},
          { text: "FECHA ACTIVACION", value: "fini", sortable: false , class: 'my-header-style'},
          { text: "FECHA VENCIMIENTO", value: "ffin", sortable: false , class: 'my-header-style'},
          { text: "OBSERVACIONES", value: "obs", sortable: false, class: 'my-header-style' },
          { text: "ESTADO", value: "est", sortable: false, class: 'my-header-style' },        
         { text: "OPCIONES", value: "actions", sortable: false },
  
        ],
        headersPagosgestion: [
            
            { text: "ITEM", value: "nomits", sortable: false , class: 'my-header-style'},
            { text: "FECHA DE PAGO", value: "fec", sortable: false , class: 'my-header-style'},
            { text: "FACTURA", value: "factura", sortable: false , class: 'my-header-style'},
            { text: "DESCUENTO", value: "descuen", sortable: false, class: 'my-header-style' },
            { text: "MONTO PAGADO(Bs)", value: "monto", sortable: false, class: 'my-header-style' },        
            { text: "MONTO DEUDA(Bs)", value: "deud", sortable: false, class: 'my-header-style' },

            ],
        datosDeudaObservacion:[],
        headersObservacion1: [
          { text: "FECHA DE REGISTRO", value: "registrado", sortable: false, class: 'my-header-style'  },
          { text: "CATEGORIA", value: "categ", sortable: false, class: 'my-header-style'  },
          { text: "RESOLUCION", value: "resol", sortable: false, class: 'my-header-style'  },
          { text: "FECHA RESOLUCION", value: "fecha", sortable: false , class: 'my-header-style' },
          { text: "OBSERVACION", value: "observ", sortable: false, class: 'my-header-style'  },
          //{ text: "TOTAL(Bs)", value: "totales", sortable: false },
         // { text: "OPCIONES", value: "actions", sortable: false }
        ],
        user: {},
        usuario: "",
        id_sede: "",
        nomus: "",
        patus: "",
        matus: "",
        id_documento: "",
        datosTipoDocumento: "",
  
        id_tipo_documento: "",
        tipo_doc_nom: "",
        iddocseg2: "",
        documento2: "",
        nivelMinimo: "",
        datosfechavigente :[],
        select: "",
        selectAño: "",
        selectCiudad: "",
        selectPais: "",
        tituloObtenido: "",
        institucion: "",
        areaEstudios: null,
        añoObtencion: "",
        cargaHoraria: null,
        datosPais: [],
        datosCiudad: [],
        tpFormacion: "",
        datosFormacionAcademica: [],
        selectPais1: "",
        act: 0,
        idForm: "",
        botonAct: 0,
  
        flag: 1,
        num:7889115
  
      };
    },
  //  mounted(){
  //     axios
  //      .get('http://192.168.1.4:8088/api/person/add')
  //      .then(response => (this.datosApis = response))
   // },
    created: function () {
      this.user = JSON.parse(sessionStorage.getItem("session"));
      this.usuario = this.user.personal;
      this.id_sede = this.user.id_sede;
      this.sede = this.user.sede;
      this.nomus = this.user.nombres + " " + this.user.paterno + " " + this.user.materno;
      
  
    },
    computed: {},
    components: {
      VueHtml2pdf,
  
    },
  
    methods: {     
       sacarFechaActual(){
     this.fechaVencimientoActual1 = new Date();
     this.fechaVencimientoActual1 = 
     this.fechaVencimientoActual1.getFullYear()+ "-" + 
     (this.fechaVencimientoActual1.getMonth() +1) + "-" + this.fechaVencimientoActual1.getDate() ;
      
           
   },
   async listarmolinete() {
     let me = this;
     await axios
       .get("/molinetes/listarmolinetes")
       .then(function (response) {
         if (response.data == null) {
           me.datosmolinetes = [];
          // console.log(me.datosmolinetes);
         } else {
           me.datosmolinetes = response.data.data.data;
           //console.log("ASDASD");
           //console.log(me.datosmolinetes);
         }
       })
       .catch(function (error) {});
   },
      activarTarjeta(item) {
        this.idTarjeta = item.idtarje;
        this.onTarjetaEstudiante(this.idTarjeta);
      },
      desactivarTarjeta(item) {
        this.idTarjeta = item.idtarje;
        this.offTarjetaEstudiante(this.idTarjeta);
      },
      registrarTarjeta(){
        this.numeroTarjeta=Number(this.numeroTarjeta);
        this.sacarFechaActual();
        this.addTarjetaEstudiante();
        this.addTarjetaPersonalApi1();
  
      },
       async addTarjetaEstudiante(
        unicodigo,
        num_documento,
        idTarjeta,
        observaciones,
        id_sede
      ) {
        let me = this;
  
        //let me=this;
        await axios
          .post(
            "/estudiante/addEstudianteTarjetaMolinete/" +
            this.unicodigo +
            "," +
            this.num_documento +
            "," +
            this.numeroTarjeta +
            "," +
            this.observaciones +
            "," +
            this.id_sede +
              "," +
              this.nuevaFechaVencimiento1
  
  
          )
          .then(function (response) {
  
            me.mensajeSnackbar = response.data.message;
            me.snackbarOK = true;
            me.closeTarjeta();
            me.listarTarjetasEstudiante();
            me.limpiar();
  
          })
          .catch(function (error) {
            me.snackbarError = true;
  
          });
  
  
  
      },
       async addTarjetaPersonalApi() {
        let me = this;
  
        //let me=this;
        await axios
          .post("/molinetes/addMolinetes/" +
              this.num_documento +
              "," +
              this.deptCode +
              "," +
              this.nombres +
              "," +
              this.paterno +
              "," +
              this.numeroTarjeta +
              "," +
              this.accLevelIds +
              "," +
              this.fechaVencimientoActual +
              "," +
              this.nuevaFechaVencimiento )
          .then(function (response) {
            me.mensajeSnackbar = response.data.message;
            me.snackbarOK = true;
          })
          .catch(function (error) {
            me.snackbarError = true;
          });
      },
      async addTarjetaPersonalApi1() {
        let me = this;
  
        //let me=this;
        await axios
          .post("/molinetes/addMolinetes/" +
              this.num_documento +
              "," +
              this.deptCode +
              "," +
              this.nombres +
              "," +
              this.paterno +
              "," +
              this.numeroTarjeta +
              "," +
              this.accLevelIds +
              "," +
              this.fechaVencimientoActual1 +
              "," +
              this.nuevaFechaVencimiento1 )
          .then(function (response) {
            me.mensajeSnackbar = response.data.message;
            me.snackbarOK = true;
           
          })
          .catch(function (error) {
            me.snackbarError = true;
          });
      },
      seleccionarTarjetaEstudiante(){
         
  this.actualizartarest(this.unicodigo,this.id_sede,this.idGestion)
         //this.showModificarTarjeta();      
     
        
      },
  
      async actualizartarest(unicodigo,id_sede,idGestion) {
        let me = this;
  
        //let me=this;
        await axios
          .post("/molinetes/actarestsd/" +
              this.unicodigo +
              "," +
              this.id_sede +
              "," +
              this.idGestion)
          .then(function (response) {
            me.mensajeSnackbar = response.data.message;
            me.snackbarOK = true;
            me.listarTarjetasEstudiante();
          })
          .catch(function (error) {
            me.snackbarError = true;
          });
      },
      actualizarTarjetaEstudiante(){
        
      this.actTarjetaEstudiante();
      this.addTarjetaPersonalApi();
        
      },
       async actTarjetaEstudiante(
      
        idTarjeta,
        observaciones,
        id_sede
      ) {
        let me = this;
  
        //let me=this;
        await axios
          .post(
            "/estudiante/actualizarTarjetaEstudiante/" +
            this.nuevaFechaVencimiento +
            "," +
            this.idTarjeta +
            "," +
            this.observaciones
  
  
          )
          .then(function (response) {
  
            me.mensajeSnackbar = response.data.message;
            me.snackbarOK = true;
            me.closeModificarTarjeta();
            me.listarTarjetasEstudiante();
           
  
          })
          .catch(function (error) {
            me.snackbarError = true;
  
          });
  
  
  
      },
       async onTarjetaEstudiante(
        unicodigo,
    
      ) {
        let me = this;
  
        //let me=this;
        await axios
          .post(
            "/estudiante/onTarjetaEstudiante/" +
            this.idTarjeta 
  
          )
          .then(function (response) {
  
            me.mensajeSnackbar = response.data.message;
           // me.snackbarOK = true;       
            me.listarTarjetasEstudiante();
            me.limpiar();
           
          })
          .catch(function (error) {
            me.snackbarError = true;
  
          });
  
      },
       async offTarjetaEstudiante(
        unicodigo,
    
      ) {
        let me = this;
  
        //let me=this;
        await axios
          .post(
            "/estudiante/offTarjetaEstudiante/" +
            this.idTarjeta
  
          )
          .then(function (response) {
  
            me.mensajeSnackbar = response.data.message;
            //me.snackbarOK = true;       
            me.listarTarjetasEstudiante();
            me.limpiar();
           
          })
          .catch(function (error) {
            me.snackbarError = true;
  
          });
  
      },
    
      async beforeDownload({ html2pdf, options, pdfContent }) {
        await html2pdf()
          .set(options)
          .from(pdfContent)
          .toPdf()
          .get("pdf")
          .then((pdf) => {
            const totalPages = pdf.internal.getNumberOfPages();
            for (let i = 1; i <= totalPages; i++) {
              pdf.setPage(i);
              pdf.setFontSize(8);
              pdf.setTextColor(100);
              pdf.text(
                "Página " + i + " / " + totalPages,
                pdf.internal.pageSize.getWidth() * 0.86,
                pdf.internal.pageSize.getHeight() - 11.01
              );
            }
          })
          .save();
      },
     
  
    
     
      imprimirHorario() {
  
        const html2PdfComponent = this.$refs.horario;
        html2PdfComponent.generatePdf();
      },
      getFilaColor(index) {
        const colors = ['lightgray', 'white']; // Define los colores que deseas utilizar
  
        // Asigna un color diferente a cada fila basado en el índice de iteración
        const colorIndex = index % colors.length;
        const color = colors[colorIndex];
  
        return {
          backgroundColor: color,
        };
      },
  
      remplazoBrPorLinea(text) {
        return text.replace(/<br>/g, '\n');
      },
      limpiarApell() {
        this.pat = "";
        this.mat = "";
        this.uniest = "";
      },
      aumentarEspacios() {
        if (this.pat != "" && this.mat == "") {
          this.mat = " ";
        } else {
          if (this.pat == "" && this.mat != "") {
            this.pat = " ";
          } else {
  
          }
        }
      },
      extraerCantMateriasTomadasEst() {
  
  
        this.cantidadActualMaterias = this.datosCantMateriasEst[0].cantmat;
       
  
      },
  
  
      getColor(insc) {
        if (insc == 'LIBRE') return 'green'
        else return '#868582'
      },
      getColorActivo(insc) {
        if (insc == 'ACTIVO') return 'green'
        else return 'red'
      },
      getColorDeuda(estado1) {
            if (estado1 == '0') return 'green'
           else if (estado1 >  0) return 'red'
           
        },
      getColorGrupos(insc) {
        if (insc == 'TEORICO') return 'light-blue accent-2'
        else return 'orange accent-2'
      },
      async listarTurno() {
        let me = this;
        await axios
          .get("/estudiante/listarTurnoIns/" + this.idGestion + "," + this.idPlanestudio + "," + this.id_sede)
          .then(function (response) {
            if (response.data.resultado == null) {
              me.datosTurno = [];
  
            } else {
  
              me.datosTurno = response.data.resultado;
            }
          })
          .catch(function (error) {
  
          });
      },
  
  
        
    
     
  
      async listarCarrera(unicodigo) {
        let me = this;
        await axios
          .get("/estudiante/listarcarreraestu/" + this.unicodigo)
          .then(function (response) {
            if (response.data.resultado == null) {
              me.datosCarrera = [];
  
            } else {
  
              me.datosCarrera = response.data.resultado;
            }
          })
          .catch(function (error) {
  
          });
      },
      async listarGestion(unicodigo,id_sede) {
        let me = this;
        await axios
          .get("/pagos/ultimagestestudi/" + this.unicodigo + "," + this.id_sede)
          .then(function (response) {
            if (response.data.resultado == null) {
              me.datosGestion = [];
              me.snackbarOK = true;
              me.mensajeSnackbar = "EL ESTUDIANTE NO TIENE TOMA DE MATERIAS !!!";
            } else {
              me.datosGestion = response.data.resultado;
              me.gestion = me.datosGestion[0].nombre;
              me.idGestion = me.datosGestion[0].idge;
              me.listarBecaest(me.unicodigo,me.id_sede,me.idGestion);
            }
          })
          .catch(function (error) {});
      },
      
   
      async listarTarjetasEstudiante(unicodigo, idGestion) {
  
        let me = this;
        await axios
          .get("/estudiante/listarTarjetaEstudiante/" + this.id_sede + "," + this.unicodigo)
          .then(function (response) {
            if (response.data.resultado == null) {
              me.datosTarjetasEstudiante = [];
              me.listarGestion(me.unicodigo,me.id_sede);
            } else {
  
              me.datosTarjetasEstudiante= response.data.resultado;
              me.listarGestion(me.unicodigo,me.id_sede);
            
            }
          })
          .catch(function (error) {
  
          });
      },
    
     
  
  
      imprimirKardex() {
       
        const html2PdfComponent = this.$refs.kardex;
        html2PdfComponent.generatePdf();
  
      },
  
      validate() {
        this.$refs.form.validate();
      },
      reset() {
        this.$refs.form.reset();
      },
      resetValidation() {
        this.$refs.form.resetValidation();
      },
      change(event) {
        let val = event.target.value.trim();
        // Solo puede ser un entero positivo o vacío, el regular se puede modificar según las necesidades
        //item = e.target.value.replace(/[^\d]/g,'')
        if (/^[1-9]\d*$|^$/.test(val)) {
          this.oldNum = val;
        } else {
          event.target.value = this.oldNum;
        }
      },
  
      buscarEstudiante() {
          //this.aumentarEspacios();
         
          if (this.uniest != "") {
            this.listarEstudianteUnicod(this.uniest, this.id_sede);
          } else {
            this.listarEstudiante(this.pat, this.mat,this.nomest, this.id_sede);
          }
        },
  
        async listarEstudiante(pat, mat,nomest, id_sede) {
          if (this.pat == "") {
            this.auxpat = "XXX"
          } else {
            this.auxpat = this.pat
          }
          if (this.mat == "") {
            this.auxmat = "XXX"
          } else {
            this.auxmat = this.mat
          }
          if (this.nomest == "") {
            this.auxnomest = "XXX"
          } else {
            this.auxnomest = this.nomest
          }
          let me = this;
          await axios
            .get("/estudiante/buscarestapell33/" + this.auxpat + "," + this.auxmat + "," + this.auxnomest + "," + this.id_sede)
            .then(function (response) {
              if (response.data.resultado == null) {
                me.datosEstudiante = [];
                me.limpiarApell();
                me.snackbarOK = true;
                me.mensajeSnackbar = response.data.message;
    
              } else {
    
                me.datosEstudiante = response.data.resultado;
                me.limpiarApell();
              }
            })
            .catch(function (error) {
    
            });
    
        },
      async listarEstudianteUnicod(uniest, id_sede) {
  
        let me = this;
        await axios
          .get("/estudiante/buscaestunicodigoinsc/" + this.uniest + "," + this.id_sede)
          .then(function (response) {
            if (response.data.resultado == null) {
              me.datosEstudiante = [];
              me.limpiarApell();
              me.snackbarOK = true;
              me.mensajeSnackbar = response.data.message;
  
            } else {
  
              me.datosEstudiante = response.data.resultado;
              me.limpiarApell();
            }
          })
          .catch(function (error) {
  
          });
  
      },
      seleccionarEstudiante(item) {
  
        this.id_estudiante = item.idest;
        this.unicodigo = item.unicod;
        this.paterno = item.pat;
        this.materno = item.mat;
        this.nombres = item.nom;
        this.nombreCompleto = item.nom + " " + item.pat + " " + item.mat;
        this.num_documento=item.numdoc;
        this.urlFoto = item.urlimage;
        this.carrera=item.carre;
        this.elModal = false;
        
        this.listarTarjetasEstudiante();
       
        
        //this.listarDocumentoPendiente();
        //this.limpiar();
        //this.establecerMateriaRecursada(this.unicodigo);
     
      },
     
   
  
   
     
     
  
     
  
      seleccionarGrupoPractico(item) {
  
        this.idGrupoDocente = item.idgr;
        this.idTipoModalidad = item.idmod;
        this.modalidad = item.modalidad;
        this.paralelo = item.gru;
        this.capacidad = item.capac;
        this.tipoGrupo = item.tpgrup;
        this.idNivel = item.idniv;
  
        this.gruposPracticosModal = false;
        this.verificarPreinscipcionNotaPractica();
  
  
      },
   
      seleccionarGestion(item) {
        this.gestion = item.nom;
        this.idGestion = item.id_gestion;
        this.gestionModal = false;
        this.listarBecaest(this.unicodigo,this.id_sede,this.idGestion);
      },
      async listarBecaest(unicodigo,id_sede,idGestion) {
      let me = this;
      await axios
        .get("/pagos/listarbecaestudi/" + this.unicodigo + "," + this.id_sede + "," + this.idGestion)
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosBeca = [];
            me.bandbeca = "";
            me.beca ="";
            me.listarDeudaaestges(me.unicodigo,me.id_sede,me.idGestion);
          
          } else {

            me.datosBeca = response.data.resultado;
            me.beca = me.datosBeca[0].nombeca;
            me.bandbeca = "TIENEBECA";
            me.listarDeudaaestges(me.unicodigo,me.id_sede,me.idGestion);

          }
        })
        .catch(function (error) {

        });
    },
    async listarDeudaaestges(unicodigo,id_sede,idGestion) {
      let me = this;
      await axios
        .get("/pagos/listardeudaestudi/" + this.unicodigo + "," + this.id_sede + "," + this.idGestion)
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosDeudaxgesestudiante = [];
            me.listarObserest(me.unicodigo,me.idGestion,me.id_sede);
            me.snackbarOK = true;
            me.mensajeSnackbar = "EL ESTUDIANTE NO TIENE DEUDA ASIGANARA PARA ESTA GESTION !!!";
           
          
          } else {

            me.datosDeudaxgesestudiante = response.data.resultado;
            me.listarObserest(me.unicodigo,me.idGestion,me.id_sede);
           

          }
        })
        .catch(function (error) {

        });
    },
    async listarObserest(unicodigo,idGestion,id_sede) {
        let me = this;
        await axios
          .get("/pagos/listarpagosobser/" + this.unicodigo + "," + this.idGestion + "," + this.id_sede)
          .then(function (response) {
            if (response.data.resultado == null) {
              me.datosDeudaObservacion = [];
              me.listarpostrgacionest(me.unicodigo,me.id_sede,me.idGestion);
            } else {
  
              me.datosDeudaObservacion = response.data.resultado;
              me.listarpostrgacionest(me.unicodigo,me.id_sede,me.idGestion);
            }
          })
          .catch(function (error) {
  
          });
      },
      async listarpostrgacionest(unicodigo,id_sede,idGestion) {
      let me = this;
      await axios
        .get("/pagos/listarplazoestudi/" + this.unicodigo + "," + this.id_sede + "," + this.idGestion)
        .then(function (response) {
          if (response.data.resultado == null) {
            me.datosfechavigente  = [];
            me.fechavigente = "";
            me.banderafechavigente = 0;
           // me.beca ="";
           // me.listarDeudaaestges(me.unicodigo,me.id_sede,me.idGestion);
          
          } else {

            me.datosfechavigente = response.data.resultado;
            me.fechavigente = me.datosfechavigente[0].fpazo;
            me.banderafechavigente = 1;
            //me.bandbeca = "TIENEBECA";
            //me.listarDeudaaestges(me.unicodigo,me.id_sede,me.idGestion);

          }
        })
        .catch(function (error) {

        });
    },
      seleccionarTurno(item) {
        this.turno = item.turno;
        this.idTurno = item.idturno;
        this.turnoModal = false;
  
        this.listarHorario(this.unicodigo, this.idGestion, this.idPlanestudio);
        this.listarFranjaHoraria(this.unicodigo);
        this.listarOfertaMaterias(this.unicodigo, this.idPlanestudio, this.idGestion);
        this.listarGruposPreInscripcion(this.idPlanestudio, this.id_sede, this.idGestion, this.idTurno, this.idTipoModalidad, this.unicodigo);
  
  
      },
      showBuscarEstudiante() {
        //this.limpiar();
        this.elModal = true;
  
      },
      showHorario() {
        //this.limpiar();
  
        this.horarioModal = true;
        //this.listarCarrera(this.unicodigo);
      },
      closeHorario() {
        this.horarioModal = false;
      },
      showDocumento() {
  
        //this.listarDocumento(this.unicodigo);
        this.documentosModal = true;
  
      },
      closeDocumento() {
        this.documentosModal = false;
      },
      showTarjeta() {      
        this.tarjetaModal = true;
       
      },
      closeTarjeta() {
        this.tarjetaModal = false;
      },
       showModificarTarjeta() {      
        
        this.modificarTarjetaModal = true;
       //this.actTarjetaEstudiante();
       
      },
      closeModificarTarjeta() {
        this.modificarTarjetaModal = false;
      },
      showGestion() {
        //this.limpiar();
        this.gestionModal = true;
        this.listarGestion();
      },
      closeGestion() {
        this.gestionModal = false;
      },
      showTurno() {
        //this.limpiar();
        this.turnoModal = true;
        this.listarTurno();
      },
      closeTurno() {
        this.turnoModal = false;
      },
  
  
      showDetalleInscripcion(item) {
  
        this.detalleModal = true;
        this.idMateria = item.idmat;
  
        this.listarGruposInscripcion(this.idMateria, this.idTurno, this.idGestion);
      },
      closeDetalleInscripcion() {
        this.detalleModal = false;
      },
      showGruposPractica() {
  
        this.gruposPracticosModal = true;
        //this.idMateria = item.idmat;   
        this.listarGruposInscripcionPractica(this.idMateria, this.idTurno, this.idGestion);
        //this.tienePractico = 'FALSE';
  
      },
      closeGruposPractica() {
        this.gruposPracticosModal = false;
      },
  
  
      limpiar() {
        //this.id_docente="";
        //this.tipodocente="";
        this.numeroTarjeta = "";
        this.observaciones = "NINGUNA";
       
  
      },
  
     
  
   
    
     
     
  
  
      deleteItem(item) {
        this.editedIndex = item.nitf;
        this.editedItem = item.nitf;
        // this.dialogDelete = true
      },
  
  
      close() {
        this.elModal = false;
      },
      showCompromiso() {
        this.compromisoModal = true;
  
      },
      closeCompromiso() {
        this.compromisoModal = false;
      },
      showKardex() {
        this.kardexModal = true;
  
      },
      closeKardex() {
        this.kardexModal = false;
      },
      showRegcompromiso(item) {
        this.iddocseg1 = item.iddocseg
        this.documento1 = item.documento
        this.regcompromisoModal = true;
      },
      closeRegcompromiso() {
        this.regcompromisoModal = false;
      },
     
      realizarcompromiso() {
        this.regcompromisoModal = false;
        this.registrarcompromisodoc(this.iddocseg1, this.fplazo);
  
  
        // this.registrarcobrodetalle(this.id_docente)
      },
  
  
  
  
    },
  };
  </script>
  <style>
  .page-number {
    position: absolute;
    bottom: 10px;
    right: 10px;
    font-size: 10px;
    color: #333;
  }
  .my-header-style {
    background: #F0F4C3;
   
  }
 
  .img12 {
      margin: 10px;
      border-radius: 20%;
      box-shadow: 0px 0px 9px 4px #EE680B;
      animation: glow 1.5s linear infinite alternate;
    }
    
    @keyframes glow{
      to {
        box-shadow: 0px 0px 10px 10px #002245;
      }
    }
  </style>
  
  
  
  
  
  
  
  